import type { IconData } from '@stacksjs/iconify-core'

export const bell: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 10c10.582 0 19.337 7.828 20.789 18.009c.233 1.64-1.128 2.991-2.785 2.991H5.996c-1.657 0-3.019-1.35-2.785-2.991C4.663 17.828 13.417 10 24 10\"/><path d=\"M24 15c5.756 0 10.755 3.242 13.27 8m4.875 14.091c1.21.016 2.51.423 2.77 1.604c.053.239.085.507.085.805s-.032.566-.085.805c-.26 1.181-1.56 1.588-2.77 1.604C39.416 41.944 33.582 42 24 42s-15.416-.056-18.145-.091c-1.21-.016-2.51-.423-2.77-1.604C3.032 40.066 3 39.798 3 39.5s.032-.566.085-.805c.26-1.181 1.56-1.588 2.77-1.604C8.584 37.056 14.418 37 24 37s15.416.056 18.145.091M24 4v6m4-6h-8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bell
